<template>
  <vs-popup class=""
            id="popup"
            title="REPLICATE RAW MATERIAL"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
                <small class="label">Supplier product name</small>
                <vs-input disabled type="text"  name="supplier_product_code" class="w-full" v-model="supplier_product_name"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="supplier_product_code" name="supplier_product_code" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Code</small>
                <vs-input v-model="form.supplier_product_code" name="supplier_product_code"  class="w-full required" label=""  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="supplier_product_name" name="supplier_product_name" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Name</small>
                <vs-input name="supplier_product_name" v-model="form.supplier_product_name"  class="w-full required" label=""  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
<!--          <div class="row mb-3">-->
<!--            <div class="vx-col md:w-ful w-full md:mb-0">-->
<!--              <ValidationProvider vid="raw_material_stage" name="raw_material_stage" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Stage (development,production)</small>-->
<!--                <v-select name="raw_material_stage" :closeOnSelect="true" v-model="form.raw_material_stage" :options="['production', 'development']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

          <div class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Save</vs-button>
            <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {},
      form: {
        supplier_id: 1
      },
      countryCodes: [],
      sites: [],
      raw_material_id: null,
      site_id: null,
      supplier_product_name: null
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, supplier_product_name) {
      try {
        await Object.assign(this.$data, initialState())
        this.raw_material_id = id
        this.supplier_product_name = supplier_product_name
        this.open = true;
      } catch (error) {


      }
    },
    async onClickUpdate () {
      const vue = this;
      this.$vs.loading()
       try {
         await SupplierRawMaterialRepository.replicateRawMaterialFromExisting(this.raw_material_id, this.form)
         this.showSuccessMessage('Raw material created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
